import { Link } from 'react-router-dom';
import { ArrowUpRight, Shield } from 'lucide-react';

export default function AuditLogSection() {
  return (
    <section className="card p-6">
      <div className="flex items-start gap-3">
        <div className="rounded-lg bg-rose-500/10 p-2 text-rose-400">
          <Shield className="h-5 w-5" />
        </div>
        <div className="flex-1">
          <h2 className="text-lg font-semibold text-ink-primary">Audit log</h2>
          <p className="mt-1 text-sm text-ink-secondary">
            Owner impersonation and other audited admin actions are available on the audit log page.
          </p>
          <Link
            to="/admin/audit"
            className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-gold hover:text-gold-light"
          >
            Open audit log
            <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
